import { DistanceUnit } from "shared/types";

export const formatDistance = (
  distance: number /* in meters */,
  unit: DistanceUnit = "metric",
) => {
  if (unit === "metric") {
    if (distance < 1000) {
      return `${Math.round(distance)} m`;
    }
    return `${(distance / 1000).toFixed(1)} km`;
  }

  // For imperial units
  const miles = distance * 0.000621371;
  if (miles < 1) {
    return `${Math.round(distance * 3.28084)} ft`;
  }
  return `${miles.toFixed(0)} mi`;
};
